module.exports = {
    handle: (e, response, step) => { 
        let productsData = response ? JSON.parse(response) : [];          
        const checkoutURL = $('#gtm-checkout-products').attr('data-gtm-checkoutURL');

        const products = productsData.map(function (elem) {
            return {
                name: elem.name,
                id: elem.id,
                price: elem.price,
                brand: elem.brand,
                category: elem.category,
                variant: elem.variant,
                quantity: elem.quantity
            }
        });

        const customerId = productsData[0] && productsData[0].customerId ? productsData[0].customerId : null;
        const emailAddress = productsData[0] && productsData[0].emailAddress ? productsData[0].emailAddress : null;

        const checkoutData = {
            event: 'eec.checkout',
            ecommerce: {
                checkout: {
                    actionField: {
                        step: step || 1,
                    },
                    products: products
                },
                eventCallback: function() {
                    document.location = checkoutURL;
                }
            }
        };

        customerId ? checkoutData.customerId = customerId : null;
        emailAddress ? checkoutData.emailAddress = emailAddress : null;

        dataLayer.push({ ecommerce: null });
        dataLayer.push(checkoutData);
    }
}